import * as React from "react"
import Video from "@components/Video"

const StrapiVideo = ({
    youtubeId
}: GatsbyTypes.VideoFragment) => {
    if (!youtubeId) {
        return
    }

    return <Video youtubeId={youtubeId} />
}

export default StrapiVideo
